module.exports = __webpack_public_path__ + "static/main-banner-a8f6e645090181d341f291226841ac44.jpg";